import React, { useState, useEffect } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  Button,
  Table,
  CardFooter,
  Col,
} from "reactstrap";
import { useHistory, Link, useParams } from "react-router-dom";
import Select from "react-select";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import Pagination from "../../../../../containers/pages/Pagination";
import { FiFlag } from "react-icons/fi";
import Accordion from "react-bootstrap/Accordion";
import { JobService } from "../../../../../services/JobService";
import { getEnumLists as getMetaJobEnums } from "../../../../../services/MetadataService";
import { isNullOrEmpty } from "../../../../../config/ENV";
import { formattedMobileNumber } from "../../../../../utilities/phonenumberutility";
import SvgUpArrow from "../../../../../components/svg/uparrow";
import SvgSelectedDownArrow from "../../../../../components/svg/selecteddownarrow";
import SvgSelectedUpArrow from "../../../../../components/svg/selecteduparrow";
import SvgDownArrow from "../../../../../components/svg/downarrow";

const ViewCandidate = (props) => {
  const history = useHistory();
  const { parentCallback } = props;
  const [currentPage, setCurrentPage] = useState(1);
  let [itemsPerPage, setItemsPerPage] = useState();
  const [selectedPageSize, setSelectedPageSize] = useState(1);

  const [totalPage, setTotalPage] = useState(1);
  const [search, setSearch] = useState("");
  const [jobStatus, setJobStatus] = useState("");

  const startIndex = (currentPage - 1) * selectedPageSize;
  const endIndex = currentPage * selectedPageSize;

  const [size, setSize] = useState();
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortBy, setSortBy] = useState("status");
  const [showApplicants, setShowApplicants] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [candidateStatusoptions, setcandidateStatusoptions] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [candidateStatus, setcandidateStatus] = useState([]);
  const [candidateStatuses, setcandidateStatuses] = useState([]);
  const [jobDetails, setJobDetials] = useState("");
  const [fitType, setFitType] = useState("");
  const [minPreferFitScore, setMinPreferFitScore] = useState();
  const [maxPreferFitScore, setMaxPreferFitScore] = useState();
  const [minSkillsFitScore, setMinSkillsFitScore] = useState();
  const [maxSkillsFitScore, setMaxSkillsFitScore] = useState();
  const [appliedWithIn, setAppliedWithIn] = useState("");
  const [publicStatus, setPublicStatus] = useState("");
  const [applicationId, setApplicationId] = useState("");
  const { id,jobreqid } = useParams();
  const Back = () => {
    history.push("/requests");
  };

  const [isSortBySelected, setIsSortBySelected] = useState(false);

  const sortByCandidates = (col) => {
    setIsSortBySelected(true);
    setSortBy(col);
    sortedOrder(col, true);
  };
  const sortedOrder = (col, isSortBySelected) => {
    var select = "";
    if (sortOrder === "desc") {
      setSortOrder("asc");
      select = "asc";
    } else {
      setSortOrder("desc");
      select = "desc";
    }
    getAllCandidates(select, col, currentPage, isSortBySelected);
  };
  const timeDifference = (updatedOn) => {
    let createdDate = new Date(updatedOn);
    let today = new Date();

    const oneSecond = 1000;
    const oneMinute = 60 * oneSecond;
    const oneHour = 60 * oneMinute;
    const oneDay = 24 * oneHour;

    const timeDiff = today.getTime() - createdDate.getTime();

    if (timeDiff < oneMinute) {
      const seconds = Math.floor(timeDiff / oneSecond);
      return (
        <span>
          {seconds === 1 ? `${seconds} second ago` : `${seconds} seconds ago`}
        </span>
      );
    } else if (timeDiff < oneHour) {
      const minutes = Math.floor(timeDiff / oneMinute);
      return (
        <span>
          {minutes === 1 ? `${minutes} minute ago` : `${minutes} minutes ago`}
        </span>
      );
    } else if (timeDiff < oneDay) {
      const hours = Math.floor(timeDiff / oneHour);
      return (
        <span>{hours === 1 ? `${hours} hour ago` : `${hours} hours ago`}</span>
      );
    } else {
      const days = Math.floor(timeDiff / oneDay);
      return <span>{days === 1 ? `${days} day` : `${days} days`}</span>;
    }
  };

  const sortByJobs = (e) => {
    setFitType(e.target.value);
    const fitScoreValue = e.target.value.split("-");

    if (fitScoreValue[0] === "skillsFitScore" && fitScoreValue[1] === "asc") {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    } else {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    }

    if (
      fitScoreValue[0] == "preferencesFitScore" &&
      fitScoreValue[1] == "asc"
    ) {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    } else {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    }
    if (fitScoreValue[0] == "fitScore" && fitScoreValue[1] == "asc") {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    } else {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    }
    if (fitScoreValue[0] === "status" && fitScoreValue[1] === "asc") {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    } else {
      setSortBy(fitScoreValue[0]);
      setSortOrder(fitScoreValue[1]);
    }
  };

  const filterStatus = (statusList) => {
    if (statusList.length > 0) {
      var status = [];
      statusList.map((statusValue, i) => {
        status.push({
          label: `${statusValue.value}`,
          value: `${statusValue.key}`,
        });
        setcandidateStatusoptions(status);
      });
    }
  };
  const searchCandidate = () => {
    setCurrentPage(1);
    getAllCandidates();
  };
  const getAllCandidates = () => {
    if (itemsPerPage === undefined || itemsPerPage === "") {
      itemsPerPage = 25;
    }

    if (candidateStatuses.length > 0) {
      candidateStatuses.map((reqStatus, index) => {
        const id = reqStatus.value;
        candidateStatus.push(id);
      });
      setcandidateStatus(candidateStatus);
    }
    const jobId = window.localStorage.getItem("requestId");

    var appliedWithInDays = "";
    if (!isNullOrEmpty(appliedWithIn)) {
      appliedWithInDays = appliedWithIn;
    }

    var minPreferFitScoreValue = "";
    if (!isNullOrEmpty(minPreferFitScore)) {
      minPreferFitScoreValue = getScoreValue(minPreferFitScore);
    }

    var maxPreferFitScoreValue = "";
    if (!isNullOrEmpty(maxPreferFitScore)) {
      maxPreferFitScoreValue = getScoreValue(maxPreferFitScore);
    }

    var minSkillsFitScoreValue = "";
    if (!isNullOrEmpty(minSkillsFitScore)) {
      minSkillsFitScoreValue = getScoreValue(minSkillsFitScore);
    }

    var maxSkillsFitScoreValue = "";
    if (!isNullOrEmpty(maxSkillsFitScore)) {
      maxSkillsFitScoreValue = getScoreValue(maxSkillsFitScore);
    }

    JobService.getJobCandidateService(
      id,
      candidateStatus,
      appliedWithIn,
      minPreferFitScoreValue,
      maxPreferFitScoreValue,
      minSkillsFitScoreValue,
      maxSkillsFitScoreValue,
      itemsPerPage,
      currentPage,
      sortBy,
      sortOrder
    ).then((response) => {
      let size = response.data.size;

      setSize(size);

      try {
        if (response.message != null) {
          if (response.data.error_message !== "") {
          }
        } else {
          if (response.data != null) {
            setShowApplicants(response.data.applicantsStatus);
            setCandidates(response.data.applicants);

            const pages = Math.floor(size / itemsPerPage);
            if (Math.round(size % itemsPerPage) > 0) {
              const totalPages = pages + 1;
              setTotalPage(totalPages);
            } else {
              const totalPages = pages;
              setTotalPage(totalPages);
            }
          }
        }
      } catch (err) {}
    });
  };
  let count = 0;

  useEffect(() => {
    if (id != 0) {
      getAllCandidates(sortOrder, sortBy, currentPage, isSortBySelected);
    }
  }, [itemsPerPage, currentPage, sortBy, sortOrder]);

  useEffect(() => {
    getJobEnums();
    if (id != 0) {
      getJobDetails();
    }
  }, [count]);

  const getJobEnums = () => {
    getMetaJobEnums().then((response) => {
      if (response !== null) {
        let jobApplicantTypes = response.jobApplicantTypes;
        if (jobApplicantTypes != null) {
          filterStatus(jobApplicantTypes);
        }
      }
    });
  };

  const getJobDetails = () => {
    try {
      var jobDetails = props.jobDetails;
      if (jobDetails != null) {
        setJobDetials(jobDetails);
        if (jobDetails.jobStatus !== null) {
          setJobStatus(jobDetails.jobStatus.value);
        }
        if (jobDetails.publicTitle !== null) {
          setPublicStatus(jobDetails.publicTitle);
        }
      }
    } catch (err) {
      console.log("message" + JSON.stringify(err.message));
    }
  };

  function handleJobStatusSelectChange(e, key) {
    setcandidateStatus([]);
    setcandidateStatuses(e);
  }

  function handleSearch(e, key) {
    setSearch(e.target.value);
  }

  function handleItemsPerChange(e, key) {
    setCurrentPage(1);
    setItemsPerPage(e.target.value);
  }

  function onChangePage(e) {
    setCurrentPage(e);
  }
  function handleMinPreferFitScore(e) {
    setMinPreferFitScore(handleDecimalsOnValue(e.target.value));
  }
  function handleMaxPreferFitScore(e) {
    setMaxPreferFitScore(e.target.value);
  }
  function handleMinSkillsFitScore(e) {
    setMinSkillsFitScore(handleDecimalsOnValue(e.target.value));
  }
  function handleMaxSkillsFitScore(e) {
    setMaxSkillsFitScore(e.target.value);
  }

  function handleAppliedWithIn(e) {
    const result = e.target.value.replace(/\D/g, "");
    setAppliedWithIn(result);
  }

  const getSerialNumber = (index) => {
    if (itemsPerPage == undefined || itemsPerPage == "") {
      itemsPerPage = 25;
    }
    return (currentPage - 1) * itemsPerPage + index + 1;
  };

  const getScore = (value) => {
    const score = (value / 20).toFixed(1);
    return score;
  };

  const getScoreValue = (value) => {
    const score = (value * 20).toFixed(1);
    return Math.floor(score);
  };

  const handleDecimalsOnValue = (value) => {
    const regex = /([0-9]*[\.|\,]{0,1}[0-9]{0,2})/s;
    return value.match(regex)[0];
  };

  const showContactNumber = (phoneNumber) => {
    if (phoneNumber.length > 0) {
      var countryCode = phoneNumber.slice(0, phoneNumber.length - 10);
      var number = phoneNumber.slice(
        phoneNumber.length - 10,
        phoneNumber.length
      );
      var requiredNumberFormat =
        number.slice(0, 3) + "-" + number.slice(3, 6) + "-" + number.slice(6);
      if (!isNullOrEmpty(countryCode)) {
        return countryCode + "-" + requiredNumberFormat;
      }
      return "+1-" + requiredNumberFormat;
    }
    return;
  };

  const showApplicantStatusCount = (list) => {
    let appCount = 0;
    let consCount = 0;
    let ta_RejCount = 0;
    let archCount = 0;
    let joinCount = 0;
    let declinedCount = 0;
    let selCount = 0;
    let jobAccCount = 0;
    let interCount = 0;
    let requestedCount = 0;
    let complCount = 0;
    let taShortCount = 0;
    let shortCount = 0;
    let rejCount = 0;
    let witCount = 0;
    let onHmsCount = 0;
    let interview = 0;
    let jobOffer = 0;

    for (let i = 0; i < list.length; i++) {
      if (list[i].status.key === "APPLIED") {
        appCount = list[i].count;
      }
      if (list[i].status.key === "CONSIDERING") {
        consCount = list[i].count;
      }
      if (list[i].status.key === "TA_REJECTED") {
        ta_RejCount = list[i].count;
      }

      if (list[i].status.key === "ARCHIVE") {
        archCount = list[i].count;
      }
      if (list[i].status.key === "JOINED") {
        joinCount = list[i].count;
      }
      if (list[i].status.key === "DECLINED") {
        declinedCount = list[i].count;
      }
      if (list[i].status.key === "SELECTED_FOR_HIRE") {
        selCount = list[i].count;
      }
      if (list[i].status.key === "JOB_OFFER_ACCEPTED") {
        jobAccCount = list[i].count;
      }

      if (list[i].status.key === "INTERVIEW_SCHEDULED") {
        interCount = list[i].count;
      }
      if (list[i].status.key === "INTERIVIEW_REQUESTED") {
        requestedCount = list[i].count;
      }
      if (list[i].status.key === "INTERIVIEW_COMPLETED") {
        complCount = list[i].count;
      }
      if (list[i].status.key === "TA_SHORT_LISTED") {
        taShortCount = list[i].count;
      }
      if (list[i].status.key === "SHORTLISTED") {
        shortCount = list[i].count;
      }

      if (list[i].status.key === "REJECTED") {
        rejCount = list[i].count;
      }
      if (list[i].status.key === "WITHDRAWN") {
        witCount = list[i].count;
      }

      jobOffer = jobAccCount + selCount;

      interview = interCount + requestedCount + complCount;

      onHmsCount =
        joinCount +
        declinedCount +
        selCount +
        interCount +
        taShortCount +
        rejCount +
        witCount;
    }
    return (
      <>
        <Col sm={3}>
          <b className="col-6"> Job Offer : {jobOffer}</b>
        </Col>
        <Col sm={2}>
          <b className="col-6"> Interview : {interview}</b>
        </Col>
        <Col sm={3}>
          <b className="col-6"> Shortlisted : {shortCount}</b>
        </Col>
        <Col sm={2}>
          <b className="col-6"> New Candidate : {taShortCount}</b>
        </Col>
        <Col sm={3}>
          <b className="col-6"> Awaiting : {appCount}</b>
        </Col>
        <Col sm={2}>
          <b className="col-6"> Considering : {consCount}</b>
        </Col>
        <Col sm={3}>
          <b className="col-6"> Rejected : {rejCount}</b>
        </Col>
        <Col sm={2}>
          <b className="col-6"> Declined : {declinedCount}</b>
        </Col>
        <Col sm={2}>
          <b className="col-6"> Total : {size}</b>
        </Col>
      </>
    );
  };

  return (
    <>
      <div>
        <script
          src="https://cdn.jsdelivr.net/npm/react/umd/react.production.min.js"
          crossOrigin="true"
        ></script>

        <script
          src="https://cdn.jsdelivr.net/npm/react-dom/umd/react-dom.production.min.js"
          crossOrigin="true"
        ></script>

        <script
          src="https://cdn.jsdelivr.net/npm/react-bootstrap@next/dist/react-bootstrap.min.js"
          crossOrigin="true"
        ></script>

        <script>var Alert = ReactBootstrap.Alert;</script>

        <div>
          <Card>
            <Accordion defaultActiveKey="0" className="Search-accordion">
              <div className="job-req-search-card">
                <Accordion.Item eventKey="0">
                  <Accordion.Header className="search-accordion-header ">
                    Search
                  </Accordion.Header>

                  <Accordion.Body>
                    <Row>
                      <Colxx sm={12}>
                        <Row>
                          <Colxx
                            sm={12}
                            className="mb-2"
                            style={{ padding: "0px" }}
                          >
                            <Select
                              isMulti
                              closeMenuOnSelect={false}
                              placeholder="Select Candidate Status"
                              className="req_dropdown col-sm-12 "
                              onChange={(e) => handleJobStatusSelectChange(e)}
                              options={candidateStatusoptions}
                            />
                          </Colxx>

                          <Colxx sm={4}>
                            <Input
                              placeholder="Number of Days Ago"
                              className="req_dropdown col-sm-12 t-rounded-lg"
                              value={appliedWithIn}
                              onChange={handleAppliedWithIn}
                            />
                          </Colxx>
                          <Colxx sm={4}>
                            <Input
                              placeholder="Min Preferences score"
                              className="req_dropdown col-sm-12 t-rounded-lg"
                              value={minPreferFitScore}
                              onChange={handleMinPreferFitScore}
                            />
                          </Colxx>

                          <Colxx sm={4}>
                            <Input
                              placeholder="Min Skills score"
                              className="req_dropdown col-sm-12 t-rounded-lg"
                              value={minSkillsFitScore}
                              onChange={handleMinSkillsFitScore}
                            />
                          </Colxx>

                          <Colxx sm={4}>
                            <Input
                              className="t-rounded-lg"
                              type="select"
                              value={fitType}
                              onChange={sortByJobs}
                            >
                              <option value={""}>Sort By</option>
                              <option value={"status-desc"}>
                                Status ( Descending )
                              </option>
                              <option value={"status-asc"}>
                                Status ( Ascending )
                              </option>
                              <option value={"fitScore-desc"}>
                                Fit score ( High-Low )
                              </option>

                              <option value={"fitScore-asc"}>
                                Fit score ( Low-High )
                              </option>
                              <option value={"skillsFitScore-desc"}>
                                Skills score ( High-Low )
                              </option>
                              <option value={"skillsFitScore-asc"}>
                                Skills score ( Low-High )
                              </option>
                              <option value={"preferencesFitScore-desc"}>
                                Preferences score ( High-Low )
                              </option>

                              <option value={"preferencesFitScore-asc"}>
                                Preferences score ( Low-High )
                              </option>
                            </Input>
                          </Colxx>

                          <Colxx sm={4}></Colxx>
                          <Colxx sm={4}>
                            <Input
                              className="t-rounded-lg"
                              type="select"
                              value={itemsPerPage}
                              onChange={handleItemsPerChange}
                            >
                              <option value={""}>Items Per Page</option>
                              <option value={"10"}>10</option>
                              <option value={"25"}>25</option>
                              <option value={"50"}>50</option>
                              <option value={"100"}>100</option>
                            </Input>
                          </Colxx>
                        </Row>
                      </Colxx>
                    </Row>

                    <Row className="mt-2">
                      <Colxx sm={12}>
                        <Row>
                          <Colxx sm={4}>
                            <Button
                              color="primary"
                              size="sm"
                              outline
                              onClick={searchCandidate}
                            >
                              Search
                            </Button>
                          </Colxx>
                        </Row>
                      </Colxx>
                    </Row>
                  </Accordion.Body>
                </Accordion.Item>
              </div>
            </Accordion>

            <hr></hr>

            <Row className="mt-1 t-ws">
              <div className="col-lg-8 t-pr">
                <Row>{showApplicantStatusCount(showApplicants)}</Row>
              </div>
              {/* <div className="col-lg-2 t-pr"></div> */}
              <div className="col-lg-4 t-pr">
                <Row>
                  <Col sm={6}>
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.5 10.5C13.5 10.0858 13.8358 9.75 14.25 9.75H18C18.4142 9.75 18.75 10.0858 18.75 10.5C18.75 10.9142 18.4142 11.25 18 11.25H14.25C13.8358 11.25 13.5 10.9142 13.5 10.5Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M13.5 13.5C13.5 13.0858 13.8358 12.75 14.25 12.75H18C18.4142 12.75 18.75 13.0858 18.75 13.5C18.75 13.9142 18.4142 14.25 18 14.25H14.25C13.8358 14.25 13.5 13.9142 13.5 13.5Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.63452 9.75C7.80609 9.75 7.13452 10.4216 7.13452 11.25C7.13452 12.0784 7.80609 12.75 8.63452 12.75C9.46295 12.75 10.1345 12.0784 10.1345 11.25C10.1345 10.4216 9.46295 9.75 8.63452 9.75ZM5.63452 11.25C5.63452 9.59315 6.97767 8.25 8.63452 8.25C10.2914 8.25 11.6345 9.59315 11.6345 11.25C11.6345 12.9069 10.2914 14.25 8.63452 14.25C6.97767 14.25 5.63452 12.9069 5.63452 11.25Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M8.63434 14.2441C8.13474 14.2441 7.64935 14.4104 7.2547 14.7168C6.86004 15.0231 6.57857 15.4521 6.45465 15.9361C6.35191 16.3373 5.94333 16.5793 5.54206 16.4766C5.14079 16.3738 4.89878 15.9653 5.00152 15.564C5.20806 14.7574 5.67718 14.0424 6.33494 13.5318C6.9927 13.0213 7.80168 12.7441 8.63434 12.7441C9.467 12.7441 10.276 13.0213 10.9337 13.5318C11.5915 14.0424 12.0606 14.7574 12.2671 15.564C12.3699 15.9653 12.1279 16.3738 11.7266 16.4766C11.3253 16.5793 10.9168 16.3373 10.814 15.9361C10.6901 15.4521 10.4086 15.0231 10.014 14.7168C9.61932 14.4104 9.13393 14.2441 8.63434 14.2441Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M2.25 5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H20.25C21.0784 3.75 21.75 4.42157 21.75 5.25V18.75C21.75 19.5784 21.0784 20.25 20.25 20.25H3.75C2.92157 20.25 2.25 19.5784 2.25 18.75V5.25ZM20.25 5.25H3.75V18.75H20.25V5.25Z"
                          fill="black"
                        />
                      </svg>
                      - Fit score
                    </div>
                  </Col>

                  <Col sm={6}>
                    <div>
                      <svg
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.25 12C11.25 11.5858 11.5858 11.25 12 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.25 6C11.25 5.58579 11.5858 5.25 12 5.25H20.25C20.6642 5.25 21 5.58579 21 6C21 6.41421 20.6642 6.75 20.25 6.75H12C11.5858 6.75 11.25 6.41421 11.25 6Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M11.25 18C11.25 17.5858 11.5858 17.25 12 17.25H20.25C20.6642 17.25 21 17.5858 21 18C21 18.4142 20.6642 18.75 20.25 18.75H12C11.5858 18.75 11.25 18.4142 11.25 18Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.17635 3.99156C9.45716 4.29606 9.43795 4.77054 9.13345 5.05135L5.88032 8.05135C5.5928 8.3165 5.14978 8.31618 4.86264 8.05062L3.24076 6.55062C2.93667 6.26937 2.91814 5.79486 3.19939 5.49077C3.48063 5.18667 3.95515 5.16814 4.25924 5.44939L5.37261 6.4791L8.11656 3.94866C8.42106 3.66785 8.89554 3.68706 9.17635 3.99156Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.17635 9.99156C9.45716 10.2961 9.43795 10.7705 9.13345 11.0513L5.88032 14.0514C5.5928 14.3165 5.14978 14.3162 4.86264 14.0506L3.24076 12.5506C2.93667 12.2694 2.91814 11.7949 3.19939 11.4908C3.48063 11.1867 3.95515 11.1681 4.25924 11.4494L5.37261 12.4791L8.11656 9.94866C8.42106 9.66785 8.89554 9.68706 9.17635 9.99156Z"
                          fill="black"
                        />
                        <path
                          fillRule="evenodd"
                          clipRule="evenodd"
                          d="M9.17635 15.9916C9.45716 16.2961 9.43795 16.7705 9.13345 17.0514L5.88032 20.0514C5.5928 20.3165 5.14978 20.3162 4.86264 20.0506L3.24076 18.5506C2.93667 18.2694 2.91814 17.7949 3.19939 17.4908C3.48063 17.1867 3.95515 17.1681 4.25924 17.4494L5.37261 18.4791L8.11656 15.9487C8.42106 15.6679 8.89554 15.6871 9.17635 15.9916Z"
                          fill="black"
                        />
                      </svg>
                      - Preferences fit
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div className="bold">
                      <div>
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M9 21H15M9 21V16M9 21H3.6C3.26863 21 3 20.7314 3 20.4V16.6C3 16.2686 3.26863 16 3.6 16H9M15 21V9M15 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H15.6C15.2686 3 15 3.26863 15 3.6V9M15 9H9.6C9.26863 9 9 9.26863 9 9.6V16"
                            stroke="black"
                            strokeWidth="1.5"
                          />
                        </svg>
                        - Skills fit
                      </div>
                    </div>
                  </Col>
                  <Col sm={6}>
                    <div>
                      <div>
                        <FiFlag color="black" />- Credibility Issue
                      </div>
                    </div>
                  </Col>
                </Row>
              </div>
            </Row>

            <CardBody>
              <Colxx xxs="12" style={{ padding: "0px" }}>
                <div>
                  <Table className="table-responsive ">
                    <thead>
                      <tr>
                        <th className="w-5">S.No</th>
                        <th className="w-10">Name </th>
                        <th className="w-10"> Email </th>
                        <th className="w-10"> Phone Number </th>
                        <th
                          className="w-5"
                          onClick={() => sortByCandidates("fitScore")}
                        >
                          <Row className="w-[50]">
                            <div className="col pr-1 t-cursor-pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M13.5 10.5C13.5 10.0858 13.8358 9.75 14.25 9.75H18C18.4142 9.75 18.75 10.0858 18.75 10.5C18.75 10.9142 18.4142 11.25 18 11.25H14.25C13.8358 11.25 13.5 10.9142 13.5 10.5Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M13.5 13.5C13.5 13.0858 13.8358 12.75 14.25 12.75H18C18.4142 12.75 18.75 13.0858 18.75 13.5C18.75 13.9142 18.4142 14.25 18 14.25H14.25C13.8358 14.25 13.5 13.9142 13.5 13.5Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.63452 9.75C7.80609 9.75 7.13452 10.4216 7.13452 11.25C7.13452 12.0784 7.80609 12.75 8.63452 12.75C9.46295 12.75 10.1345 12.0784 10.1345 11.25C10.1345 10.4216 9.46295 9.75 8.63452 9.75ZM5.63452 11.25C5.63452 9.59315 6.97767 8.25 8.63452 8.25C10.2914 8.25 11.6345 9.59315 11.6345 11.25C11.6345 12.9069 10.2914 14.25 8.63452 14.25C6.97767 14.25 5.63452 12.9069 5.63452 11.25Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M8.63434 14.2441C8.13474 14.2441 7.64935 14.4104 7.2547 14.7168C6.86004 15.0231 6.57857 15.4521 6.45465 15.9361C6.35191 16.3373 5.94333 16.5793 5.54206 16.4766C5.14079 16.3738 4.89878 15.9653 5.00152 15.564C5.20806 14.7574 5.67718 14.0424 6.33494 13.5318C6.9927 13.0213 7.80168 12.7441 8.63434 12.7441C9.467 12.7441 10.276 13.0213 10.9337 13.5318C11.5915 14.0424 12.0606 14.7574 12.2671 15.564C12.3699 15.9653 12.1279 16.3738 11.7266 16.4766C11.3253 16.5793 10.9168 16.3373 10.814 15.9361C10.6901 15.4521 10.4086 15.0231 10.014 14.7168C9.61932 14.4104 9.13393 14.2441 8.63434 14.2441Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M2.25 5.25C2.25 4.42157 2.92157 3.75 3.75 3.75H20.25C21.0784 3.75 21.75 4.42157 21.75 5.25V18.75C21.75 19.5784 21.0784 20.25 20.25 20.25H3.75C2.92157 20.25 2.25 19.5784 2.25 18.75V5.25ZM20.25 5.25H3.75V18.75H20.25V5.25Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                            <div className="col mt-1">
                              {sortBy == "fitScore" ? (
                                <>
                                  {sortBy === "fitScore" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <Row>
                                          <SvgSelectedUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgDownArrow />
                                        </Row>
                                      </>
                                    ) : (
                                      <>
                                        <Row>
                                          <SvgUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgSelectedDownArrow />
                                        </Row>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Row>
                                    <SvgUpArrow />
                                  </Row>
                                  <Row>
                                    <SvgDownArrow />
                                  </Row>
                                </>
                              )}
                            </div>
                          </Row>
                        </th>
                        <th
                          className="w-5"
                          onClick={() => sortByCandidates("skillsFitScore")}
                        >
                          <Row className="w-[50]">
                            <div className="col pr-1 t-cursor-pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M9 21H15M9 21V16M9 21H3.6C3.26863 21 3 20.7314 3 20.4V16.6C3 16.2686 3.26863 16 3.6 16H9M15 21V9M15 21H20.4C20.7314 21 21 20.7314 21 20.4V3.6C21 3.26863 20.7314 3 20.4 3H15.6C15.2686 3 15 3.26863 15 3.6V9M15 9H9.6C9.26863 9 9 9.26863 9 9.6V16"
                                  stroke="black"
                                  strokeWidth="1.5"
                                />
                              </svg>
                            </div>
                            <div className="col mt-1">
                              {sortBy == "skillsFitScore" ? (
                                <>
                                  {sortBy === "skillsFitScore" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <Row>
                                          <SvgSelectedUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgDownArrow />
                                        </Row>
                                      </>
                                    ) : (
                                      <>
                                        <Row>
                                          <SvgUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgSelectedDownArrow />
                                        </Row>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Row>
                                    <SvgUpArrow />
                                  </Row>
                                  <Row>
                                    <SvgDownArrow />
                                  </Row>
                                </>
                              )}
                            </div>
                          </Row>
                        </th>
                        <th
                          className="w-5"
                          onClick={() =>
                            sortByCandidates("preferencesFitScore")
                          }
                        >
                          <Row className="w-[50]">
                            <div className="col pr-1 t-cursor-pointer">
                              <svg
                                width="24"
                                height="24"
                                viewBox="0 0 24 24"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.25 12C11.25 11.5858 11.5858 11.25 12 11.25H20.25C20.6642 11.25 21 11.5858 21 12C21 12.4142 20.6642 12.75 20.25 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.25 6C11.25 5.58579 11.5858 5.25 12 5.25H20.25C20.6642 5.25 21 5.58579 21 6C21 6.41421 20.6642 6.75 20.25 6.75H12C11.5858 6.75 11.25 6.41421 11.25 6Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M11.25 18C11.25 17.5858 11.5858 17.25 12 17.25H20.25C20.6642 17.25 21 17.5858 21 18C21 18.4142 20.6642 18.75 20.25 18.75H12C11.5858 18.75 11.25 18.4142 11.25 18Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.17635 3.99156C9.45716 4.29606 9.43795 4.77054 9.13345 5.05135L5.88032 8.05135C5.5928 8.3165 5.14978 8.31618 4.86264 8.05062L3.24076 6.55062C2.93667 6.26937 2.91814 5.79486 3.19939 5.49077C3.48063 5.18667 3.95515 5.16814 4.25924 5.44939L5.37261 6.4791L8.11656 3.94866C8.42106 3.66785 8.89554 3.68706 9.17635 3.99156Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.17635 9.99156C9.45716 10.2961 9.43795 10.7705 9.13345 11.0513L5.88032 14.0514C5.5928 14.3165 5.14978 14.3162 4.86264 14.0506L3.24076 12.5506C2.93667 12.2694 2.91814 11.7949 3.19939 11.4908C3.48063 11.1867 3.95515 11.1681 4.25924 11.4494L5.37261 12.4791L8.11656 9.94866C8.42106 9.66785 8.89554 9.68706 9.17635 9.99156Z"
                                  fill="black"
                                />
                                <path
                                  fillRule="evenodd"
                                  clipRule="evenodd"
                                  d="M9.17635 15.9916C9.45716 16.2961 9.43795 16.7705 9.13345 17.0514L5.88032 20.0514C5.5928 20.3165 5.14978 20.3162 4.86264 20.0506L3.24076 18.5506C2.93667 18.2694 2.91814 17.7949 3.19939 17.4908C3.48063 17.1867 3.95515 17.1681 4.25924 17.4494L5.37261 18.4791L8.11656 15.9487C8.42106 15.6679 8.89554 15.6871 9.17635 15.9916Z"
                                  fill="black"
                                />
                              </svg>
                            </div>
                            <div className="col mt-1">
                              {sortBy == "preferencesFitScore" ? (
                                <>
                                  {sortBy === "preferencesFitScore" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <Row>
                                          <SvgSelectedUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgDownArrow />
                                        </Row>
                                      </>
                                    ) : (
                                      <>
                                        <Row>
                                          <SvgUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgSelectedDownArrow />
                                        </Row>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Row>
                                    <SvgUpArrow />
                                  </Row>
                                  <Row>
                                    <SvgDownArrow />
                                  </Row>
                                </>
                              )}
                            </div>
                          </Row>
                        </th>
                        <th className="w-5">Applied</th>
                        <th
                          className="w-5"
                          onClick={() => sortByCandidates("status")}
                        >
                          <Row className="w-[100]">
                            <div className="col pr-1 t-cursor-pointer">
                              Status
                            </div>
                            <div className="col">
                              {sortBy == "status" ? (
                                <>
                                  {sortBy === "status" ? (
                                    sortOrder === "asc" ? (
                                      <>
                                        <Row>
                                          <SvgSelectedUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgDownArrow />
                                        </Row>
                                      </>
                                    ) : (
                                      <>
                                        <Row>
                                          <SvgUpArrow />
                                        </Row>
                                        <Row>
                                          <SvgSelectedDownArrow />
                                        </Row>
                                      </>
                                    )
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  <Row>
                                    <SvgUpArrow />
                                  </Row>
                                  <Row>
                                    <SvgDownArrow />
                                  </Row>
                                </>
                              )}
                            </div>
                          </Row>
                        </th>
                        <th className="w-5">
                          <FiFlag title="Credibility Issue" />
                        </th>
                        <th className="w-5"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {candidates.length > 0 ? (
                          candidates.map((candidate, index) => {
                            return (
                              <>
                                <tr key={index}>
                                  <td>{getSerialNumber(index)}</td>
                                  <td>
                                    {candidate.firstName} {candidate.lastName}
                                  </td>
                                  <td>{candidate.email}</td>
                                  <td>
                                    {formattedMobileNumber(
                                      candidate.contactNumber
                                    )}
                                  </td>
                                  <td>{getScore(candidate.fitScore)}</td>
                                  <td>{getScore(candidate.skillFitScore)}</td>
                                  <td>
                                    {getScore(candidate.preferenceFitScore)}
                                  </td>
                                  <td>
                                    {candidate.appliedStatusDuration == 1 ? (
                                      <>{candidate.appliedStatusDuration} day</>
                                    ) : (
                                      <>
                                        {candidate.appliedStatusDuration ==
                                        0 ? (
                                          <>Today</>
                                        ) : (
                                          <>
                                            {candidate.appliedStatusDuration}
                                            days
                                          </>
                                        )}
                                      </>
                                    )}
                                  </td>
                                  <td>
                                    {candidate.applicationStatus.value}
                                    <br />
                                    {candidate.statusChangeDuration == 1 ? (
                                      <>({candidate.statusChangeDuration}day)</>
                                    ) : (
                                      <>
                                        {candidate.statusChangeDuration == 0 ? (
                                          <>(Today)</>
                                        ) : (
                                          <>
                                            ({candidate.statusChangeDuration}
                                            days)
                                          </>
                                        )}
                                      </>
                                    )}
                                    <br />
                                  </td>
                                  {candidate.credibility === 1 ? (
                                    <>
                                      <td style={{ color: "orange" }}>
                                        <FiFlag title="Credibility Issue" />
                                      </td>
                                    </>
                                  ) : (
                                    <>
                                      {candidate.credibility === 0 ? (
                                        <td></td>
                                      ) : (
                                        <td style={{ color: "red" }}>
                                          <FiFlag title="Credibility Issue" />
                                        </td>
                                      )}
                                    </>
                                  )}
                                  <td>
                                    <div className="row">
                                      <Link
                                        to={{pathname:`/viewcandidatedetails/${id}/${candidate.applicationId}`,
                                        state: {componentName: "addrequest"}} }  
                                      
                                        className="ml-3 mr-1"
                                        title="View Candidate"
                                      >
                                        <i className="simple-icon-eye edit-copyiconsize arrow-icon-color" />
                                      </Link>
                                      {candidate.taActionRequired == true ? (
                                        <Link 
                                        to={""}
                                          className="ml-3 mr-1"
                                          title="Client Asked A Question/Comment"
                                        >
                                          <i className="simple-icon-bell edit-copyiconsize arrow-icon-color" />
                                        </Link>
                                      ) : (
                                        <></>
                                      )}
                                    </div>
                                  </td>
                                </tr>
                              </>
                            );
                          })
                        ) : (
                          <></>
                        )}
                      </>
                    </tbody>
                  </Table>
                  <div>
                    {candidates.length == 0 && (
                      <h4
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <strong>No data found</strong>
                      </h4>
                    )}
                  </div>
                </div>
              </Colxx>
            </CardBody>
            <CardFooter>
              <Row className="wrapper">
                <h3 className="ml-3 matrecords">
                  Total matching records : {size}
                </h3>

                <Pagination
                  currentPage={currentPage}
                  totalPage={totalPage}
                  numberLimit={itemsPerPage}
                  firstIsActive={true}
                  onChangePage={(e) => onChangePage(e)}
                />
              </Row>

              <div className="col-6 p-0">
                <Button
                  className="mt-4 "
                  color="primary"
                  size="sm"
                  outline
                  onClick={Back}
                >
                  Back
                </Button>
              </div>
            </CardFooter>
          </Card>
        </div>
      </div>
    </>
  );
};

export default ViewCandidate;
